<template>
  <transition name="fade" mode="out-in">
    <div class="lottery-ssc">
      <div class="top-bar">
        <span class="btn-back left-arrow iconfont" @click.stop="hide()">&#xe61c;</span>
        <span class="select-text">玩法</span>
        <div class="btn-box">
          <span class="btn-select" @click.stop="showSelectBox">
            <span class="text">{{selectText}}</span>
            <span class="hhs-icon iconfont" :class="{active:showSelect}">&#xe64c;</span>
          </span>
        </div>
        <span class="btn-history" @click.stop="showHis()">历史记录</span>
        <div class="select-box" v-show="showSelect">
          <span class="select-item line" @click.stop="selectedType('pt')" :class="{active:selectType === 'pt'}">普通投注<i
            class="iconfont icon">&#xe640;</i></span>
          <span class="select-item" @click.stop="selectedType('dt')" :class="{active:selectType === 'dt'}">胆拖投注<i
            class="iconfont icon">&#xe640;</i></span>
        </div>
      </div>
      <pt v-show="selectType === 'pt'" @select="selectPt" ref="pt"></pt>
      <dtlottery v-show="selectType === 'dt'" @select="selectDt" ref="dtlottery"></dtlottery>
      <div class="bottom-bar">
        <span class="btn-random" v-show="!showClear" @click.stop="toggleChoice">机选</span>
        <span class="btn-clear" v-show="showClear" @click.stop="clear()">清空</span>
        <div class="price-box">
          <span class="price" v-show="count>0">共{{count}}注<i>{{money}}元</i></span>
        </div>
        <span class="btn-submit" @click.stop="sureCode">确定</span>
        <div class="cpChoiceBei" v-show="showChoice">
          <div class="cpChoiceBeiItem border-1px" @click.stop="choice(1)">
            <span class="cpChoiceIcon"><img src="./images/bei1.png"></span>
            <span class="cpChoiceText">1注</span>
          </div>
          <div class="cpChoiceBeiItem border-1px" @click.stop="choice(5)">
            <span class="cpChoiceIcon"><img src="./images/bei2.png"></span>
            <span class="cpChoiceText">5注</span>
          </div>
          <div class="cpChoiceBeiItem border-1px" @click.stop="choice(10)">
            <span class="cpChoiceIcon"><img src="./images/bei3.png"></span>
            <span class="cpChoiceText">10注</span>
          </div>
        </div>
      </div>
      <tooltip text="请至少选择1注" ref="tooltip"></tooltip>
      <buy v-show="showBuy && lotteryList.length > 0" :lottery-list="lotteryList" @clear="_initialize" @hide="hideBuy"
           @choice="choice"
           @remove="removeCp" @toggle="toggleCp" ref="buy"></buy>
      <history v-show="showHistory" @hide="hideHis" ref="history"></history>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
  import pt from 'components/ssc/component/pt';
  import dtlottery from 'components/ssc/component/dt';
  import buy from 'components/ssc/component/buy';
  import history from 'components/ssc/component/history';
  import tooltip from 'components/tooltip/tooltip';
  import {getRandom, getShark} from 'common/js/util';
  export default{
    data() {
      return {
        count: 0, // 选择注数
        code: '', // 选中号码
        codeResult: {},
        redNums: [],
        blueNums: [],
        lotteryList: [], // 号码列表
        selectType: 'pt',
        showHistory: false,
        showBuy: false,
        showSelect: false,
        showClear: false,
        showChoice: false,
        showTooltip: false,
        changeIndex: '',
        index: 1
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.setShark();
      });
    },
    methods: {
      hide() {
        if (this.lotteryList.length > 0) {
          this.showBuy = true;
          this.$nextTick(() => {
            this.$refs.buy._initScroll();
            this.changeIndex = '';
          });
        } else {
          this.$router.push('/');
        }
      },
      hideBuy() {
        this.showBuy = false;
      },
      showHis() {
        this.showHistory = true;
        this.$nextTick(() => {
          this.$refs.history._initScroll();
        });
      },
      hideHis() {
        this.showHistory = false;
      },
      clear() {
        this.count = 0;
        this.code = '';
        this.codeResult = {};
        this.showClear = false;
        if (this.selectType === 'pt') {
          this.$refs.pt.clearNums();
        } else {
          this.$refs.dtlottery.clearNums();
        }
      },
      sureCode() {
        if (!this.code && !this.count) {
          this.$refs.tooltip.show();
          return;
        }
        if (this.changeIndex) {
          this._updateRecord(this.changeIndex, this.selectType, this.count, this.money, this.code, this.codeResult);
        } else {
          this._addRecord(this.selectType, this.count, this.money, this.code, this.codeResult);
        }
        this.showBuy = true;
        this.$nextTick(() => {
          this.$refs.buy._initScroll();
          this.clear();
          this.changeIndex = '';
        });
      },
      removeCp(index) {
        for (let i in this.lotteryList) {
          if (this.lotteryList[i].index === index) {
            this.lotteryList.splice(i, 1);
          }
        }
      },
      toggleCp(index) {
        this.changeIndex = index;
        let item;
        let lotteryList = this.lotteryList;
        for (let i in lotteryList) {
          if (lotteryList[i].index === index) {
            item = lotteryList[i];
          }
        }
        this.selectedType(item.type);
        if (item.type === 'pt') {
          let resRed = item.result['redNums'];
          let resBule = item.result['blueNums'];
          for (let i in resRed) {
            /* eslint-disable space-infix-ops */
            this.$refs['pt'].selectRed(parseInt(resRed[i]) - 1);
          }
          for (let i in resBule) {
            /* eslint-disable space-infix-ops */
            this.$refs['pt'].selectBlue(parseInt(resBule[i]) - 1);
          }
        }
        if (item.type === 'dt') {
          let resRed1 = item.result['redNums1'];
          let resRed2 = item.result['redNums2'];
          let resBule = item.result['blueNums'];
          for (let i in resRed1) {
            /* eslint-disable space-infix-ops */
            this.$refs['dtlottery'].selectRed1(parseInt(resRed1[i]) - 1);
          }
          for (let i in resRed2) {
            /* eslint-disable space-infix-ops */
            this.$refs['dtlottery'].selectRed2(parseInt(resRed2[i]) - 1);
          }
          for (let i in resBule) {
            /* eslint-disable space-infix-ops */
            this.$refs['dtlottery'].selectBlue(parseInt(resBule[i]) - 1);
          }
        }
      },
      showSelectBox() {
        this.showSelect = !this.showSelect;
      },
      toggleChoice() {
        this.showChoice = !this.showChoice;
      },
      choice(count) {
        for (let i = 0; i < count; i++) {
          this.count = 0;
          this.code = '';
          this.codeResult = {};
          this.showChoice = false;
          this.choicePt();
        }
        this.showBuy = true;
        this.$nextTick(() => {
          this.$refs.buy._initScroll();
          this.clear();
          this.changeIndex = '';
        });
      },
      choicePt() {
        let redNums = getRandom(33, 6);
        let blueNums = getRandom(16, 1);
        this.codeResult = {
          redNums: redNums,
          blueNums: blueNums
        };
        this.code = redNums.join(',') + ';' + blueNums.join(',');
        this.count = this._caculate(6, redNums.length) * this._caculate(1, blueNums.length);
        this._addRecord('pt', this.count, this.money, this.code, this.codeResult);
      },
      sharkPt() {
        this.$refs.pt.clearNums();
        let redNums = getRandom(33, 6);
        let blueNums = getRandom(16, 1);
        for (let i in redNums) {
          /* eslint-disable space-infix-ops */
          this.$refs['pt'].selectRed(parseInt(redNums[i]) - 1);
        }
        for (let i in blueNums) {
          /* eslint-disable space-infix-ops */
          this.$refs['pt'].selectBlue(parseInt(blueNums[i]) - 1);
        }
      },
      setShark() {
        let gShark = getShark(() => {
          if (this.selectType === 'pt' && !this.showBuy && !this.showHistory) {
            this.sharkPt();
            gShark.play();
          }
        });
      },
      selectedType(type) {
        this.clear();
        this.selectType = type;
        this.showSelect = false;
        this.$nextTick(() => {
          if (type === 'pt') {
            this.$refs.pt._initScroll();
          } else {
            this.$refs.dtlottery._initScroll();
          }
        });
      },
      selectPt(redNums, blueNums) {
        this.count = 0;
        this.code = '';
        this.codeResult = {};
        this.showChoice = false;
        if (redNums.length || blueNums.length) {
          this.showClear = true;
        } else {
          this.showClear = false;
        }
        if (redNums.length < 6 || blueNums.length < 1) {
          return;
        }
        this.codeResult = {
          redNums: redNums,
          blueNums: blueNums
        };
        this.code = redNums.join(',') + ';' + blueNums.join(',');
        this.count = this._caculate(6, redNums.length) * this._caculate(1, blueNums.length);
      },
      selectDt(redNums1, redNums2, blueNums) {
        this.count = 0;
        this.code = '';
        this.codeResult = {};
        this.showChoice = false;
        if (redNums1.length || redNums2.length || blueNums.length) {
          this.showClear = true;
        } else {
          this.showClear = false;
        }
        if (!(redNums1.length > 0 && redNums2.length > 1 && (redNums1.length + redNums2.length) > 6) || blueNums.length < 1) {
          return;
        }
        this.codeResult = {
          redNums1: redNums1,
          redNums2: redNums2,
          blueNums: blueNums
        };
        this.code = redNums1.join(',') + ';' + redNums2.join(',') + ';' + blueNums.join(',');
        this.count = this._caculate(6 - redNums1.length, redNums2.length) * this._caculate(1, blueNums.length);
      },
      _initialize() {
        this.count = 0;
        this.code = '';
        this.codeResult = {};
        this.redNums = [];
        this.blueNums = [];
        this.lotteryList = [];
        this.showBuy = false;
        this.changeIndex = '';
        this.index = 1;
        if (this.selectType === 'pt') {
          this.$refs.pt.clearNums();
        } else {
          this.$refs.dtlottery.clearNums();
        }
      },
      _caculate(start, end) {
        let a = 1;
        let b = 1;
        let k = end;
        for (let i = 1; i <= end - start; i++) {
          b = b * i;
          a = a * k;
          k--;
        }
        return a / b;
      },
      _addRecord(type, count, money, code, codeResult) {
        let result = {
          type: type,
          count: count,
          money: money,
          code: code,
          result: codeResult,
          index: this.index++
        };
        this.lotteryList.push(result);
      },
      _updateRecord(index, type, count, money, code, codeResult) {
        let data = [];
        for (var i = 0; i < this.lotteryList.length; i++) {
          let item = this.lotteryList[i];
          if (item.index === parseInt(index)) {
            let result = {
              type: type,
              count: count,
              money: money,
              code: code,
              result: codeResult,
              index: index
            };
            data.push(result);
          } else {
            data.push(item);
          }
        }
        this.lotteryList = data;
      }
    },
    computed: {
      selectText() {
        if (this.selectType === 'pt') {
          return '双色球';
        } else if (this.selectType === 'dt') {
          return '双色球胆拖';
        }
      },
      money() {
        return parseInt(this.count) * 2;
      }
    },
    components: {
      pt,
      dtlottery,
      tooltip,
      buy,
      history
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  @import "../../common/stylus/mixin.styl";
  .lottery-ssc
    position:fixed
    z-index:50
    top:0
    bottom:0
    left:0
    right:0
    background-color:#f8f8f0
    &.fade-enter-active, &.fade-leave-active
      transition:all 0.4s linear
    &.fade-enter, &.fade-leave-active
      transform:translate(100%, 0)
    .top-bar
      display:flex
      position:fixed
      z-index:51
      top:0
      left:0
      width:100%
      height:40px
      background-color:#D91D36
      color:#fff
      .btn-back
        padding:0 10px
        font-size:16px
        line-height:40px
        vertical-align:top
      .select-text
        display:inline-block
        font-size:14px
        width:20px
        line-height:15px
        padding:5px
        margin-right:12px
        text-align:center
        border-left:1px solid #df4257
      .btn-box
        flex:1
        text-align:left
        .btn-select
          padding:3px 5px
          vertical-align:top
          border-radius:2px
          border:1px solid #fff
          .text
            font-size:16px
            line-height:24px
          .hhs-icon
            display:inline-block
            color:#ffd300
            &.active
              transform:rotate(180deg)
      .btn-history
        margin-right:10px
        font-size:16px
        line-height:40px
        vertical-align:top
      .select-box
        position:absolute
        left:18%
        top:41px
        z-index:52
        width:60%
        background-color:#fff
        border-left:1px solid #cdcdcd
        border-right:1px solid #cdcdcd
        font-size:0px
        .select-item
          display:inline-block
          position:relative
          padding:5px 0
          width:50%
          font-size:15px
          text-align:center
          color:#938369
          border-bottom:1px solid #cdcdcd
          &.line
            border-right:1px solid #938369
          .icon
            display:none
            position:absolute
            right:2px
            bottom:-10px
            font-size:16px
            color:#c43f52
          &.active
            color:#c43f52
            .icon
              display:block
    .bottom-bar
      display:flex
      position:fixed
      z-index:51
      bottom:0
      left:0
      width:100%
      height:50px
      background-color:#181818
      .btn-random, .btn-clear
        margin:7px 10px
        padding:8px 15px;
        font-size:18px;
        color:#f7ae2f;
        background:#333333;
      .btn-clear
        color:#fff;
      .price-box
        flex:1
        text-align:center
        .price
          font-size:14px
          line-height:50px
          color:#ffffff
          letter-spacing:2px
          i
            color:#f2cf6b
      .btn-submit
        margin:7px 10px
        padding:8px 15px;
        font-size:18px;
        color:#520d08;
        background:-webkit-gradient(linear, 0 0%, 0 100%, from(#fccd01), to(#ff8d08))
      .cpChoiceBei
        position:absolute
        z-index:52
        bottom:50px
        left:10px
        padding:0px 10px
        background-color:#fff
        border:1px solid #cdcdcd
        border-bottom:none
        .cpChoiceBeiItem
          width:100%
          border-1px(#000)
          &:last-child:after
            display:none
          .cpChoiceIcon
            display:inline-block
            height:50px
            line-height:50px
            text-align:center
            vertical-align:top
            img
              margin-top:5px
              width:40px
          .cpChoiceText
            display:inline-block
            width:50px
            font-size:18px
            line-height:50px
            text-align:right
            vertical-align:top
</style>



// WEBPACK FOOTER //
// ssc.vue?578e1f99